import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useSettings } from "../SettingsContext";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const SERVICES = [
    "Courier",
    "Air Freight",
    "Sea Freight",
    "Rail Freight",
    "Road Transport",
  ];

  const { settings } = useSettings();

  const [email, setEmail] = useState("");
  const [acceptPolicy, setAcceptPolicy] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!acceptPolicy) {
      setError("You must accept the terms and privacy policy before subscribing.");
      return;
    }

    setError("");
   window.open("http://eepurl.com/jfFDEY", "_blank");
  };

  return (
    <footer className="footer-area footer-layout-2 pos-rel pt-130 pt-md-100 pt-xs-100 fix">
      <div className="container">
        <div className="row borders-grey pb-30">
          <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp2 animated" data-wow-delay=".1s">
            <div className="footer__widget mb-30">
              <div className="footer-log">
                <Link to="/" className="logo">
                  <img src="/assets/img/logo-main.png" style={{ width: "200px" }} alt="Logo" />
                </Link>
              </div>
              <p className="mb-25">
                Your one-stop international freight comparison e-market.
              </p>
              <div className="social-links footer__social mb-25">
               {settings?.facebook_link && settings.facebook_link !== "#" && (
                  <a href={settings.facebook_link} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                )}
                {settings?.instagram_link && settings.instagram_link !== "#" && (
                  <a href={settings.instagram_link} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                )}
                {settings?.linkedin_link && settings.linkedin_link !== "#" && (
                  <a href={settings.linkedin_link} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-linkedin-in"></i>
                  </a>
                )}
                {settings?.x_link && settings.x_link !== "#" && (
                  <a href={settings.x_link} target="_blank" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                )}
              </div>
            </div>
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp2 animated" data-wow-delay=".3s">
            <div className="footer__widget mb-30 pl-40 pl-md-0 pl-xs-0">
              <h4 className="widget-title mb-30">Services</h4>
              <ul className="fot-list">
                {SERVICES.map((service) => (
                  <li key={service}>
                    <Link
                      className="dropdown-item"
                      to={`/quote/${service.toLowerCase().replace(/\s+/g, "-")}`}
                    >
                      {service}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="col-xl-3 col-lg-4 col-md-6 wow fadeInUp2 animated" data-wow-delay=".5s">
            <div className="footer__widget mb-25">
              <h4 className="widget-title mb-30">Quick Links</h4>
              <ul className="fot-list">
                <li><a href="/trackparcels">Track & Trace</a></li>
                <li><a href="/contact-us">Contact Us</a></li>
                <li><a href="/login">Login</a></li>
                <li><a href="/signup">Create Account</a></li>
              </ul>
            </div>
          </div>

          <div className="col-xl-3 col-lg-6 col-md-6 wow fadeInUp2 animated" data-wow-delay=".7s">
            <div className="footer__widget mb-30">
              <h4 className="widget-title mb-30">Newsletter</h4>
              <span className="address-details mb-25">
                Subscribe to our newsletter for new and exclusive offers.
              </span>

              <div style={{ marginBottom: "20px", marginTop: "10px" }}>
                <input
                  type="checkbox"
                  id="acceptPolicy"
                  name="acceptPolicy"
                  checked={acceptPolicy}
                  onChange={(e) => setAcceptPolicy(e.target.checked)}
                  style={{ display: "inline" }}
                />
                <label htmlFor="acceptPolicy" style={{ marginLeft: "5px", display: "inline" }}>
                  I confirm that I have read, consent and agree to ShippersWise{" "}
                  <Link to="/terms-and-conditions" style={{ textDecoration: "underline" }}>
                    Terms and Conditions
                  </Link>{" "}
                  and{" "}
                  <Link to="/privacy-policy" style={{ textDecoration: "underline" }}>
                    Privacy Policy
                  </Link>
                </label>
              </div>

              {error && (
                <div className="text-danger mb-3" style={{ fontSize: "14px" }}>
                  {error}
                </div>
              )}

              <div className="footer-layout-2 mt-25">
                <form className="subscribe-form mb-1" onSubmit={handleSubmit}>
                  <div className="input-wrapper">
                    <input
                      type="email"
                      placeholder="Email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                    <button className="footer_sub_btn" type="submit">
                      <img src="/assets/img/icon/right-arrow.svg" alt="Right Arrow" />
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>

        <div className="copy-right-area pt-50">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-7">
              <div className="copyright mb-45 text-start text-md-start">
                <p>
                  © <Link to="/">Shipperswise</Link> - Copyright {currentYear} All Right Reserved
                </p>
              </div>
            </div>
            <div className="col-lg-6 col-md-5 text-md-end">
              <div className="footer__widget mb-25">
                <ul className="fot-list d-inline-block">
                  <li><a href="/cookie-policy">Cookie Policy</a></li>
                  <li><a href="/privacy-policy">Privacy Policy</a></li>
                  <li><a href="/terms-and-conditions">Terms and Conditions</a></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
